import { SiteColors } from "../types";

export const siteColors: SiteColors = {
    Primary: '#6C757D',
    Secondary: '#F5922D',
    Tertiary: '#343A40',
    Quaternary: '#C1C8E4',
    Quinary: '#8860D0'
};